import { checkIntersectionOfTwoRectangles } from '../checkIntersectionOfTwoRectangles';
import { SUM_POINT_RADIUS_PX } from './chartConstants';
import {
	IChartParams,
	IPointWithCoordinates,
	IPointWithLabelCoordinates,
} from '../../models';

/**
 * function defines if there is an intersection between
 * first point label and second point label
 * @param firstPoint - first point
 * @param secondPoint - second point
 */
export const checkPointLabelsIntersection = (
	firstPoint: IPointWithLabelCoordinates,
	secondPoint: IPointWithLabelCoordinates,
) => {
	return checkIntersectionOfTwoRectangles(
		firstPoint.labelLeftTopX,
		firstPoint.labelLeftTopY,
		firstPoint.relativeLabelWidth,
		firstPoint.relativeLabelHeight,
		secondPoint.labelLeftTopX,
		secondPoint.labelLeftTopY,
		secondPoint.relativeLabelWidth,
		secondPoint.relativeLabelHeight,
	);
};

/**
 * function defines if there is an intersection between
 * first point label and second point dot (bubble)
 * @param firstPoint - first point
 * @param secondPoint - second point
 * @param chartParams - parameters of the XGrid chart
 */
export const checkPointLabelAndAnotherPointDotIntersection = (
	firstPoint: IPointWithLabelCoordinates,
	secondPoint: IPointWithCoordinates,
	chartParams: IChartParams,
) => {
	const { xRatio, yRatio } = chartParams;
	const pointXRelativeRadius = SUM_POINT_RADIUS_PX * xRatio;
	const pointYRelativeRadius = SUM_POINT_RADIUS_PX * yRatio;

	return checkIntersectionOfTwoRectangles(
		firstPoint.labelLeftTopX,
		firstPoint.labelLeftTopY,
		firstPoint.relativeLabelWidth,
		firstPoint.relativeLabelHeight,
		secondPoint.pointLeftTopX,
		secondPoint.pointLeftTopY,
		pointXRelativeRadius * 2,
		pointYRelativeRadius * 2,
	);
};
